import React, { useRef, useState, useEffect } from "react";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import {
  agGridOptionsNone,
  agGridTheme,
  HOST_URL,
} from "../../helpers/constants/Constants";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import {
  addMaintenance,
  updateMaintenance,
} from "../../helpers/axios/maintenanceAxios";
import Select from "react-select";
import { useSelector } from "react-redux";
import createMultiSelect from "../ag-grid/createMultiSelect";
import makeAnimated from "react-select/animated";
import CreatableSelect from "react-select/creatable";

const MaintenanceAdmin = () => {
  const { superUserDetails } = useSelector((state) => state.globalReducer);
  const [showAddModal, setShowAddModal] = useState(false);
  const [addInput, setAddInput] = useState({
    createdBy: superUserDetails?.email,
  });

  const animatedComponents = makeAnimated();

  const [selectOptionsValue, setSelectOptionsValue] = useState([]);
  const [selectOptionsInputValue, setSelectOptionsInputValue] = useState("");

  const [rowData, setRowData] = useState([]);
  const [columnDefs] = useState([
    // { headerName: "MUID", field: "muid", sortable: true, filter: true },
    {
      headerName: "Interval",
      field: "interval",
      sortable: true,
      filter: true,
      cellRenderer: (params) => {
        if (!params.data.dimension) return params.data.interval;
        const units = { D: "Day(s)", M: "Month(s)", Y: "Year(s)" };
        const unit = units[params.data.dimension] || "";
        const interval = `${params.data.interval} ${unit}`;
        return (
          interval +
          (params.data.intervalHours
            ? ` or ${Number(
                params.data.intervalHours,
              ).toLocaleString()} Hour(s)`
            : "")
        );
      },
    },
    {
      headerName: "Description",
      field: "description",
      sortable: true,
      filter: true,
      autoHeight: true,
      cellStyle: { whiteSpace: "normal", lineHeight: "1.5" },
      minWidth: 600,
    },
    {
      field: "keys",
      cellEditor: createMultiSelect,
      cellEditorPopup: true,
      editable: true,
      minWidth: 600,
      // singleClickEdit: true,
      cellEditorParams: (row) => {
        return {
          values: row.data.keys?.map((role) => {
            return role.role;
          }),
        };
      },
      onCellValueChanged: (data) => {
        updateMaintenance(data.data);
      },
    },
    {
      headerName: "Created By",
      field: "createdBy",
      sortable: true,
      filter: true,
    },
    {
      headerName: "Created Date",
      field: "createdDate",
      sortable: true,
      filter: true,
      valueFormatter: (params) => {
        return new Date(params.value).toLocaleDateString("en-gb", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });
      },
    },
  ]);

  //Load Grid DATA
  useEffect(() => {
    loadMaintenanceData();
  }, []);

  const loadMaintenanceData = () => {
    // Fetch or load your data here
    // For example, you can use an API call or static data
    axios
      .get(HOST_URL + "/maintenance/getAll")
      .then((response) => {
        const data = response.data; // Assuming the response data is an array of objects
        setRowData(data);
      })
      .catch((error) => {
        console.error("Error fetching maintenance data:", error);
        // Handle error appropriately
      });
  };

  const handleKeyDown = (event) => {
    if (!selectOptionsInputValue) return;
    switch (event.key) {
      case "Enter":
      case "Tab":
      case "ArrowRight":
        if (
          !selectOptionsValue
            ?.map((o) => o.label)
            .includes(selectOptionsInputValue)
        ) {
          var temp = [
            ...selectOptionsValue,
            { label: selectOptionsInputValue, value: selectOptionsInputValue },
          ];
          setAddInput({
            ...addInput,
            keys: temp.map((o) => o.value),
          });
          setSelectOptionsValue(temp);
        }
        setSelectOptionsInputValue("");
        event.preventDefault();
        break;
      default:
        break;
    }
  };

  return (
    <>
      <Modal
        show={showAddModal}
        onHide={(e) => {
          setShowAddModal(false);
        }}
      >
        <Modal.Header
          closeButton={(e) => {
            setShowAddModal(false);
          }}
        >
          <Modal.Title>Confirm Add</Modal.Title>
          <div
            data-bs-theme="dark"
            style={{
              position: "absolute",
              right: 20,
            }}
          >
            <button
              type="button"
              className="btn-close"
              onClick={(e) => {
                setShowAddModal(false);
              }}
              aria-label="Close"
            />
          </div>
        </Modal.Header>
        <Modal.Body>
          {/* Recieve the input from the user for the modal name and keys */}
          {/* <div className="mb-3">
            <label htmlFor="objectType" className="form-label">
              Object Type
            </label>
            <Select
              id="objectType"
              options={Array.from(new Set(allStaticObjects.map((item) => item.object.category)))
                .filter(Boolean)
                .map((type) => ({ value: type, label: type }))}
              value={addInput.object ? { value: addInput.object, label: addInput.object } : null}
              onChange={(selected) => {
                setAddInput({
                  ...addInput,
                  object: selected ? selected.value : "",
                  manufacturer: "",
                  type: "",
                  muid: "",
                });
                
              }}
              isClearable
              placeholder="Select Object Type"
            />
          </div>
          <div className="mb-3">
            <label htmlFor="manufacturer" className="form-label">
              Manufacturer
            </label>
            <Select
              id="manufacturer"
              options={Array.from(
                new Set(
                  allStaticObjects
                    .filter((item) => !addInput.object || item.object.category === addInput.object)
                    .map((item) => item.staticObjectProperties.find((prop) => prop.property?.toLowerCase() === "manufacturer")?.value)
                )
              )
                .filter(Boolean)
                .map((manufacturer) => ({ value: manufacturer, label: manufacturer }))}
              value={addInput.manufacturer ? { value: addInput.manufacturer, label: addInput.manufacturer } : null}
              onChange={(selected) => {
                setAddInput({
                  ...addInput,
                  manufacturer: selected ? selected.value : "",
                  type: "",
                  muid: "",
                });
              }}
              isClearable
              placeholder="Select Manufacturer"
            />
          </div>
          <div className="mb-3">
            <label htmlFor="type" className="form-label">
              Type
            </label>
            <Select
              id="type"
              options={Array.from(
                new Set(
                  allStaticObjects
                    .filter(
                      (item) =>
                        (!addInput.object || item.object.category === addInput.object) &&
                        (!addInput.manufacturer || item.staticObjectProperties.find((prop) => prop.property?.toLowerCase() === "manufacturer")?.value === addInput.manufacturer)
                    )
                    .map((item) => item.staticObjectProperties.find((prop) => prop.property?.toLowerCase() === "type")?.value)
                )
              )
                .filter(Boolean)
                .map((type) => ({ value: type, label: type }))}
              value={addInput.type ? { value: addInput.type, label: addInput.type } : null}
              onChange={(selected) => {
                setAddInput({
                  ...addInput,
                  type: selected ? selected.value : "",
                  muid: "",
                });
              }}
              isClearable
              placeholder="Select Type"
            />
          </div>
          <div className="mb-3">
            <label htmlFor="muid" className="form-label">
              MUID
            </label>
            <Select
              id="muid"
              options={allStaticObjects
                .filter(
                  (item) =>
                    (!addInput.object || item.object.category === addInput.object) &&
                    (!addInput.manufacturer || item.staticObjectProperties.find((prop) => prop.property?.toLowerCase() === "manufacturer")?.value === addInput.manufacturer) &&
                    (!addInput.type || item.staticObjectProperties.find((prop) => prop.property?.toLowerCase() === "type")?.value === addInput.type)
                )
                .map((item) => ({ value: item.muid, label: item.muid }))}
              value={addInput.muid ? { value: addInput.muid, label: addInput.muid } : null}
              onChange={(selected) => {
                setAddInput({ ...addInput, muid: selected ? selected.value : "" });
              }}
              isClearable
              placeholder="Select MUID"
            />
          </div> */}
          <div className="mb-3">
            <label htmlFor="keys" className="form-label">
              Keys
            </label>
            <CreatableSelect
              // components={{ DropdownIndicator: null }}
              components={animatedComponents}
              inputValue={selectOptionsInputValue}
              isClearable
              isMulti
              menuIsOpen={false}
              onChange={(newValue) => setSelectOptionsValue(newValue)}
              onInputChange={(newValue) => setSelectOptionsInputValue(newValue)}
              onKeyDown={(e) => handleKeyDown(e)}
              placeholder="Type something and press enter..."
              value={selectOptionsValue}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="interval" className="form-label">
              Interval Value
            </label>
            <input
              type="number"
              className="form-control"
              id="interval"
              placeholder="Enter Interval Value"
              value={addInput?.interval || ""}
              onChange={(e) => {
                setAddInput({ ...addInput, interval: e.target.value });
              }}
            />
          </div>
          <div className="mb-3">
            <label htmlFor="dimension" className="form-label">
              Type of Interval
            </label>
            <select
              className="form-select"
              id="dimension"
              value={addInput?.dimension || ""}
              onChange={(e) => {
                setAddInput({ ...addInput, dimension: e.target.value });
              }}
            >
              <option value="">Select Type</option>
              <option value="D">Day(s)</option>
              <option value="M">Month(s)</option>
              <option value="Y">Year(s)</option>
            </select>
          </div>
          <div className="mb-3 form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="intervalHoursCheck"
              checked={!!addInput.hasIntervalHours}
              onChange={(e) => {
                setAddInput({
                  ...addInput,
                  hasIntervalHours: e.target.checked,
                  intervalHours: e.target.checked
                    ? addInput.intervalHours || ""
                    : undefined,
                });
              }}
            />
            <label className="form-check-label" htmlFor="intervalHoursCheck">
              Add Interval Hours (optional)
            </label>
          </div>
          {addInput.hasIntervalHours && (
            <div className="mb-3">
              <label htmlFor="intervalHours" className="form-label">
                Interval Hours
              </label>
              <input
                type="number"
                className="form-control"
                id="intervalHours"
                placeholder="Enter Interval Hours"
                value={addInput.intervalHours || ""}
                onChange={(e) => {
                  setAddInput({ ...addInput, intervalHours: e.target.value });
                }}
                min="0"
              />
            </div>
          )}
          <div className="mb-3">
            <label htmlFor="description" className="form-label">
              Description
            </label>
            <textarea
              className="form-control"
              id="description"
              placeholder="Enter Description"
              value={addInput?.description || ""}
              onChange={(e) => {
                setAddInput({ ...addInput, description: e.target.value });
              }}
              rows={3}
            />
          </div>
          <div className="d-flex justify-content-end p-1">
            <button
              className="btn btn-secondary btn-sm"
              onClick={(e) => {
                setShowAddModal(false);
              }}
            >
              Cancel
            </button>
            <button
              className="btn btn-success btn-sm"
              onClick={(e) => {
                addMaintenance(addInput)
                  .then((response) => {
                    setRowData([...rowData, response.data]);
                    setShowAddModal(false);
                  })
                  .catch(console.log);
              }}
            >
              Add
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <div className="maintenance-admin">
        <h1>Maintenance</h1>
        {/* Admin buttons */}
        <div className="d-flex justify-content-end p-1">
          <button
            className="btn btn-primary btn-sm mb-2"
            onClick={(e) => {
              setShowAddModal(true);
            }}
          >
            Add Maintenance
          </button>
        </div>
        {/* Ag Grid */}
        <div id="gridStyle" style={{ height: "70VH" }}>
          <AgGridReact
            theme={agGridTheme}
            ref={useRef(null)}
            rowData={rowData}
            columnDefs={columnDefs}
            gridOptions={agGridOptionsNone}
          />
        </div>
      </div>
    </>
  );
};
export default MaintenanceAdmin;
